import * as React from 'react';

import {SelectionTable} from 'shells/table/selection-table';

import type {FormForLandingPage as Form} from 'nutshell-graphql-types';

import {useManageSpecialState} from '../consts';
import type {SelectedItem, SpecialState} from '../custom-add-on-select-modal';
import {useGetFormsForLandingPages} from '../graphql/hooks/use-get-forms-for-landing-pages';

type Props = {
    search: string;
    setSelectedItem: (item: SelectedItem) => void;
    selectedItem: SelectedItem | null | undefined;
    setSpecialState: (specialState?: SpecialState | null | undefined) => void;
};

export function FormSelectionTable(props: Props) {
    const {search, setSelectedItem, selectedItem, setSpecialState} = props;

    const {forms, isLoading, isFirstLoad, error} = useGetFormsForLandingPages(search);

    const isEmptyState = !isLoading && !error && !forms.length && !search.length;

    useManageSpecialState(isLoading, isFirstLoad, isEmptyState, setSpecialState);

    const columns = React.useMemo(
        () => [
            {
                id: 'name',
                Header: 'Form name',
                accessor: (form: Form) => form.name,
                dataType: 'string',
                shouldTruncate: true,
                width: 140,
            },
            {
                id: 'creator',
                Header: 'Creator',
                accessor: (form: Form) => form.creatorUser,
                dataType: 'linkedEntity',
                width: 140,
            },
            {
                id: 'lastUpdatedTime',
                Header: 'Last updated',
                accessor: (form: Form) => form.lastUpdatedTime,
                dataType: 'timestamp',
                width: 160,
            },
            {
                id: 'lastSubmittedTime',
                Header: 'Last submitted',
                accessor: (form: Form) =>
                    form.lastSubmittedTime ? form.lastSubmittedTime : undefined,
                dataType: 'timestamp',
                width: 160,
            },
            {
                id: 'numSubmissions',
                Header: '# Submissions',
                accessor: (form: Form) => form.numSubmissions,
                dataType: 'integer',
                width: 120,
                maxWidth: 120,
                minWidth: 120,
            },
        ],
        []
    );

    return !isFirstLoad && !isEmptyState ? (
        <SelectionTable
            hasHeaderLeftBorder={false}
            hasHeaderRightBorder={false}
            hasHeaderTopBorder={false}
            // @ts-expect-error
            columns={columns}
            data={forms}
            isLoading={isLoading}
            error={error}
            isFiltering={Boolean(search)}
            fullWidth={true}
            onSelectRow={(row) => {
                setSelectedItem({
                    value: row.original.id,
                    name: row.original.name,
                });
            }}
            selectedRowId={selectedItem ? selectedItem.value : null}
        />
    ) : null;
}
